// extracted by css-extract-rspack-plugin
export default {"custom-field":"CustomCell_custom-field__AwHVr","custom-NUMERIC":"CustomCell_custom-NUMERIC__vNsgW"};